import { useLingui } from "@lingui/react/macro";

/**
 * What a ticket came to, or an admission that nobody knows.
 *
 * An order line whose menu item has no price used to total to $0.00 — order
 * #021 read as a free Thai Vinaigrette next to a $15.00 Thai Salad (T-901).
 * Nothing is priced at zero by accident any more, so a missing price says so.
 */
export function TicketTotal({ total, className }: { total: number | null; className?: string }) {
  const { t } = useLingui();

  if (total == null) {
    return (
      <span className={className ?? "text-[0.6875rem] font-bold text-white/70"}>
        {t`No price set`}
      </span>
    );
  }

  return <>{`$${total.toFixed(2)}`}</>;
}
